import { TYPES } from "./types";
import { tkt1PCInfoService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1PCInfos = (query) => async (dispatch) => {
  try {
    const result = await tkt1PCInfoService.getPCInfos(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PC_INFOS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PC_INFOS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1PCInfoByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1PCInfoService.getPCInfoByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PC_INFO_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PC_INFO_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1PCInfoBySN = (sn) => async (dispatch) => {
  try {
    const result = await tkt1PCInfoService.getPCInfoBySN(sn);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PC_INFO_BY_SN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PC_INFO_BY_SN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1PCInfo = (pcInfoData) => async (dispatch) => {
  try {
    const result = await tkt1PCInfoService.createPCInfo(pcInfoData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_PC_INFO_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_PC_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1PCInfo = (id, pcInfoData) => async (dispatch) => {
  try {
    const result = await tkt1PCInfoService.updatePCInfo(id, pcInfoData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PC_INFO_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PC_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1PCInfoBySN = (sn, pcInfoData) => async (dispatch) => {
  try {
    const result = await tkt1PCInfoService.updatePCInfoBySN(sn, pcInfoData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PC_INFO_BY_SN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PC_INFO_BY_SN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1PCInfo = (id) => async (dispatch) => {
  try {
    const result = await tkt1PCInfoService.deletePCInfo(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_PC_INFO_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_PC_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1PCInfoAction = {
  getTKT1PCInfos,
  getTKT1PCInfoByID,
  getTKT1PCInfoBySN,
  createTKT1PCInfo,
  updateTKT1PCInfo,
  updateTKT1PCInfoBySN,
  deleteTKT1PCInfo
};
